import { ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';
import { META } from '@/config/constants';

interface PageWrapperProps {
  children: ReactNode;
  title?: string;
  description?: string;
  keywords?: string[];
  ogImage?: string;
  noIndex?: boolean;
}

const PageWrapper = ({
  children,
  title = META.DEFAULT_TITLE,
  description = META.DEFAULT_DESCRIPTION,
  keywords = META.DEFAULT_KEYWORDS as unknown as string[],
  ogImage = META.DEFAULT_OG_IMAGE,
  noIndex = false,
}: PageWrapperProps) => {
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords.join(', ')} />
        {noIndex && <meta name="robots" content="noindex" />}
        
        {/* Open Graph / Social Media Meta Tags */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={ogImage} />
        <meta property="og:type" content="website" />
        
        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={ogImage} />
      </Helmet>
      {children}
    </>
  );
};

export default PageWrapper; 